<template>


  <div :class="(loginConfig &&loginConfig.pageName &&loginConfig.pageName.indexOf('柒个贰') > -1) ? 'train-common-wrapper-BTLH':'train-common-wrapper'">
    <mescroll-vue
      ref="mescroll"
      :down="down"
    >
      <transition-group
        tag="ul"
        name="list-complete"
        class="train-common-content"
      >
        <li
          class="train-sel-box round-sm list-complete-item"
          v-for="(train,index2) in nativeList"
          :key="index2"
          @click="select(train)"
        >
          <!-- 行程信息 -->
          <van-row class="route">
            <!-- 出发信息 -->
            <van-col :span="5">
              <div class="font20 font-bold main-color">
                {{ train.startTime }}
              </div>
              <div class="font12">
                <van-tag
                  v-if="train.isStartStation"
                  class="stationTag"
                  color="#eb852b"
                >
                  始
                </van-tag>
                <van-tag
                  v-else
                  class="stationTag"
                  color="#3b94ea"
                >
                  过
                </van-tag>
                {{ train.fromStationName }}
              </div>
            </van-col>

            <!-- 历时信息 -->
            <van-col
              :span="6"
              class="trainNo font10 text-center gray"
            >
              <p>{{ train.trainCode }}</p>
              <icon-arrow-line />
              <p>{{ train.runTime }}</p>
            </van-col>

            <!-- 到达信息 -->
            <van-col
              :span="5"
              class="text-right"
            >
              <div class="font20 arriveTime font-bold">
                {{ train.arriveTime }}
                <sup
                  v-show="train.arriveDayShow"
                  class="gray font10"
                >+{{ train.arriveDays }}天</sup>
              </div>
              <div class="font12">
                <van-tag
                  v-if="train.isEndStation"
                  class="stationTag"
                  color="#369f40"
                >
                  终
                </van-tag>
                <van-tag
                  v-else
                  class="stationTag"
                  color="#3b94ea"
                >
                  过
                </van-tag>
                {{ train.toStationName }}
              </div>
            </van-col>

            <!-- 票价 -->
            <van-col
              :span="8"
              v-if="train.canBook"
              class="text-right money-color font12"
            >
              <span v-if="train.minPrice > 0">
                &yen;
                <strong
                  class="font16"
                  style="margin: 0 3px;"
                >
                  {{ train.minPrice }}
                </strong>
                <span class="gray font10">{{ $t('rise','起') }}</span>
              </span>
              <span
                v-else
                class="gray font10"
              >暂无余票</span>
            </van-col>
          </van-row>

          <!-- 座席 -->
          <van-row class="seat font10 gray">
            <template v-if="train.canBook">
              <van-col
                :span="6"
                v-for="(seat,index3) in train.seatList"
                :key="index3"
              >
                {{ seat.seatName }}
                <span
                  class="num"
                  :class="[ seat.seatCount != 0 ? 'money-color' : 'gray' ]"
                >{{ seat.seatCountStr }}</span>
              </van-col>
            </template>
            <span
              class="orange"
              v-else
            >暂未发售，起售时间：{{ train.saleDateTime }}</span>
          </van-row>
        </li>
      </transition-group>
      <ld-no-more v-show="nativeList.length > 0" font-color="#fff" style="margin-bottom: 50px;" />
      <ld-no-more v-if="emptyData" font-color="#fff" text="暂无车次~" style="margin-bottom: 50px;" />
      <div style="height:120px" />
    </mescroll-vue>


    <!-- 底部排序tabbar -->


    <van-tabbar
      v-model="filterRow"
      class="shadow"
      safe-area-inset-bottom
    >
      <van-tabbar-item
        v-for="(nav,index4) in filiterList"
        :key="index4"
        :name="nav.row"
        @click="tabbarFilter(nav)"
      >
        <span v-if="nav.sort">{{ nav.label }}</span>
        <span v-else>{{ nav.reLabel }}</span>
        <ld-icon
          :type="nav.icon"
          slot="icon"
        />
      </van-tabbar-item>

      <van-tabbar-item
        :dot="filters.length !== 0"
        @click="filterPanelShow = true"
      >
        <span>{{ $t('C121','筛选') }}</span>
        <ld-icon
          type="iconshaixuan"
          slot="icon"
        />
      </van-tabbar-item>
    </van-tabbar>

    <!-- 筛选 -->
    <train-common-filter-panel
      v-if="fromStationList.length > 0 || toStationList.length > 0"
      @on-enter="filterEnter"
      :visibility.sync="filterPanelShow"
      :to-station-list="toStationList"
      :from-station-list="fromStationList"
    />

  </div>
</template>

<script>
/**
 * @copyright (C), 2018-2019
 * @file 火车票列表公共组件
 * @desc 只需要传入火车票列表数据即可。
 *        组件创建会深拷贝一份列表数据 供筛选过滤 进行展示
 * @return {Object: Train} 回调触发 'selected' 事件把所选择车次信息作为参数
 */

import { Tabbar, TabbarItem, Divider, Tag } from 'vant'
import { mapState,mapGetters } from 'vuex'
import TrainCommonFilterPanel from './TrainCommonFilterPanel'
import iconArrowLine from 'Common/iconArrowLine'
import Train from 'Domain/entities/train'
import ldNoMore from 'Common/ldNoMore'


export default {
  components: {
    [Tabbar.name]: Tabbar,
    [Divider.name]: Divider,
    [TabbarItem.name]: TabbarItem,
    [Tag.name]: Tag,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    iconArrowLine,
    TrainCommonFilterPanel,
    ldNoMore
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      down: { use: false },
      nativeList: [],
      filters: [], // 筛选
      filterPanelShow: false,

      filterRow: '', // 当前排序的字段
      filiterList: [
        { label: '最早发车', reLabel: '最晚发车', sort: true, active: false, row: 'startTime', icon: 'iconchufashijian' },
        { label: '耗时最短', reLabel: '耗时最长', sort: true, active: false, row: 'runMinute', icon: 'iconicon04' },
        { label: '最早到站', reLabel: '最晚到站', sort: true, active: false, row: 'arriveTime', icon: 'icondaodashijian' }
      ],
      toStationList: [],
      fromStationList: [],
      emptyData: false
    }
  },
  computed: {
    ...mapGetters(['loginConfig', 'userInfo', 'loginNotices']),
  },
  created () {
    this.filterRow = this.filiterList[0].row
    this.tabbarFilter(this.filiterList[0])
  },
  methods: {
    select (train) {
      train.canBook && this.$emit('selected', train)
    },
    filterEnter(filters) {
      this.filters = filters
      /**
       * Filters格式：
       * [
       *  {
       *    row: 'startTime',
       *    title: '出发时间',
       *    result: [],
       *    list: ['00:00-06:00', '06:00-12:00', '12:00-18:00', '18:00-24:00'],
       *  },
       *  {
       *    row: 'arriveTime',
       *    title: '到达时间',
       *    result: [],
       *    list: ['00:00-06:00', '06:00-12:00', '12:00-18:00', '18:00-24:00'],
       *  },
       *  {
       *    row: 'trainType',
       *    title: '车次类型',
       *    result: [],
       *    list: ['高铁 (G/C)', '动车 (D)', '普通 (K/Z/T)'],
       *  }
       * ]
       */

      if (filters.length === 0) {
        this.nativeList = JSON.parse(JSON.stringify(this.list)).map(train => new Train(train))
      } else {
        filters.forEach((filter, index) => {
          let list = index === 0 ? this.list : this.nativeList // 第一遍过滤要用源列表，接着用过滤后的数组过滤

          switch (filter.row) {
            case 'startTime':
            case 'arriveTime':
              this.nativeList = list.filter(list => {
              /**
               * 没有选中不进行筛选
               */
                if (filter.result.length > 0) {
                  let bool = false
                  filter.result.forEach(timeparagraph => {
                    let start = timeparagraph.split('-')[0]
                    let end = timeparagraph.split('-')[1]
                    if (list[filter.row] > start && list[filter.row] < end) bool = true
                  })
                  return bool
                } else {
                  return list
                }
              })
              break
            case 'trainType':
              this.nativeList = list.filter(list => {
                if (filter.result.length > 0) {
                  let bool = false
                  filter.result.forEach(checkType => {
                    if (checkType.indexOf(list[filter.row]) > -1) bool = true
                  })
                  return bool
                } else {
                  return list
                }
              })
              break
            case 'toStationName':
            case 'fromStationName':
              this.nativeList = list.filter(list => {
                if (filter.result.length > 0) {
                  let bool = false
                  filter.result.forEach(checkType => {
                    if (checkType === list[filter.row]) bool = true
                  })
                  return bool
                } else {
                  return list
                }
              })
              break
          }
        })
      }
      this.emptyData = this.nativeList.length == 0
    },
    /**
     * 底部排序
     */
    tabbarFilter (filiter) {
      if (filiter.active) {
        filiter.sort = !filiter.sort
      } else {
        filiter.active = true
      }

      this.nativeList = this.nativeList.sort((a, b) => {
        let _a = a[this.filterRow],
          _b = b[this.filterRow]
        if (this.filterRow === this.filiterList[1].row) {
          _a = Number(_a)
          _b = Number(_b)
        } else if (this.filterRow === this.filiterList[2].row) {
          _a = a['arriveDays'] + _a
          _b = b['arriveDays'] + _b
        }

        if (filiter.sort) {
          return _b < _a ? 1 : -1
        } else {
          return _a < _b ? 1 : -1
        }
      })

      this.filiterList.forEach(_filiter => {
        if (_filiter.row != filiter.row) {
          _filiter.sort = true
          _filiter.active = false
        }
      })
    }
  },
  watch: {
    list: {
      handler (val) {
        /**
         * 在列表组件内部深拷贝一份列表数据
         * 排序和筛选不改变 list 数据，只操作 nativeList
         */
        this.nativeList = JSON.parse(JSON.stringify(val)).map(train => new Train(train, train.byTrainDate))
        this.emptyData = this.nativeList.length == 0
        /**
         * stationName
         * 统计一共有几种出发和到达站点
         * 格式: toStationList ['北京', '北京南', ...]
         */
        this.toStationList = Array.from(new Set ([...this.nativeList.map(train => train.toStationName)]))
        this.fromStationList = Array.from(new Set ([...this.nativeList.map(train => train.fromStationName)]))
      },
      deep: true
    }
  },

}
</script>

<style lang="less" scoped>
.train-common-wrapper {
    height: calc(100vh - 100px);
    overflow: hidden;
}
.train-common-wrapper-BTLH {
    height: 80vh;
    overflow: hidden;
}
.train-common-content {
	padding: 0 6px;
	.train-sel-box {
		margin-top: 2px;
		padding: 10px 10px 0;
		box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.05);
		background: white;
		.route {
			border-bottom: 1px solid @color-background-gray;
			.trainNo {
				padding: 8px 0 18px 0;
				p {
					margin-bottom: -4px;
					margin-top: -2px;
				}
				img {
					width: 52px;
				}
			}

			.arriveTime {
				position: relative;

				sup {
				position: absolute;
				width: 35px;
				letter-spacing: 1px;
				}
			}
		}
		.seat {
			padding: 10px 0;
		}
	}
}

</style>
